import http from './httpService';

export function getAllRiskSubCategories() {
  return http.get(`/risk-subcategories`);
}
export async function getAllCategoriesActive(page = 0, result = []) {
  const { data } = await http.get(`/risk-categories?page=${page}&size=20&active.equals=true`);

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllCategoriesActive(page + 1, result);
}
export async function getAllCategories(page = 0, result = []) {
  const { data } = await http.get(`/risk-categories?page=${page}&size=20`);

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllCategories(page + 1, result);
}
export function createSubCategory(payload) {
  return http.post('/risk-subcategories', payload);
}
export function deleteSubCategory(id) {
  return http.delete(`/risk-subcategories/${id}`);
}
export function updateSubCategory(payload) {
  return http.put('/risk-subcategories', payload);
}
export function deactivateRiskSubCategory(id) {
  return http.put(`/risk-subcategories/${id}/toggle-activation`);
}